import axios from "axios";

const GetShiftList = async () => {
  return axios.get(`Shift/GetShifts`).then((response) => response);
};


const AddShift = async (payload) => {
  const config = {
    method: "post",
    url: `Shift/AddShift`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const UpdateShift = async (payload) => {
  const config = {
    method: "post",
    url: `Shift/UpdateShift`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const shiftService = {
  GetShiftList,
  AddShift,
  UpdateShift,
};

export default shiftService;
